const queryParams = (params) => {
  return Object.keys(params)
    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&')
}

export const addQueryParamsToUrl = (baseUrl, params) => {
  if (!params) return baseUrl

  const character = !baseUrl.includes('?') ? '?' : '&'
  return `${baseUrl}${character}${queryParams(params)}`
}
